// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3SXQT","content":"Consent_content__1uF8V","footer":"Consent_footer__I1yQJ"};